import axios from 'axios'
import { CookieKeys, CookieService } from '@api/hooks/ambassdor/cookie-service'
import uuid from 'react-uuid'
import { to } from '@react-spring/web'

export const BASE_URL = process.env.REACT_APP_PP_API_BASE_URL

axios.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => {
    // handle the error
    return Promise.reject(error?.response || error)
  }
)

export const getRandomId = () => {
  return localStorage.getItem("uuid");
};

export const getAccessToken = () => {
  return (
    window.PWWebSDK?.accessToken ||
    localStorage.getItem('TOKEN') ||
    localStorage.getItem('token')
  )
}
const getInstance = ({ headers: _headers = {} }: { headers?: any }) => {
  // TODO: discuss with Himanshu about randomId
  let randomId =
    localStorage.getItem('uuid') ?? localStorage.getItem('randomId')
  if (randomId === null) {
    randomId = uuid()
    localStorage.setItem('randomId', randomId)
  }

  const headers: any = {
    ...{
      'Content-Type': 'application/json',
      version: '0.0.1',
      'client-id': process.env.REACT_APP_PP_ORG_ID,
      'client-version': process.env.REACT_APP_PP_CLIENT_VERSION,
      'client-type': process.env.REACT_APP_PP_CLIENT_TYPE,
      randomId: localStorage.getItem('uuid') ?? randomId,
    },
    ..._headers,
  }

  const tokenContext = getAccessToken()
    ? { token: getAccessToken() }
    : CookieService.getValue(CookieKeys.TOKEN_CONTEXT)
      ? CookieService.getValue(CookieKeys.TOKEN_CONTEXT)
      : null
  if (tokenContext) {
    headers['Authorization'] = `Bearer ${tokenContext?.token}`
  }
  if (typeof window !== 'undefined') {
    headers['randomId'] =
      localStorage.getItem('uuid') ?? localStorage.getItem('randomId')
  }

  const Instance = axios.create({
    baseURL: BASE_URL,
    timeout: 15000,
    headers: headers,
  })
  Instance.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      if (error?.response?.status === 401) {
        localStorage.clear()
      }
      // handle the error
      return Promise.reject(error?.response?.data?.error || error?.response)
    }
  )
  return Instance
}

interface Config {
  params?: any
  headers?: any
}

export const Client: any = {
  get: (endpoint: string, config: Config = {}) => {
    let params: any = []
    if (config.params) {
      for (let p in config.params) {
        let key = p
        if (Array.isArray(config.params[p])) {
          config.params[p].forEach((element: any) => {
            params.push(`${key}=${encodeURIComponent(element)}`)
          })
        } else {
          params.push(`${key}=${encodeURIComponent(config.params[p])}`)
        }
      }
    }
    const Instance = getInstance({ headers: config.headers || {} })
    return Instance(endpoint, {
      params: config.params || {},
    })
  },
  post: (endpoint: string, data: any, config: Config = {}) => {
    let params: any = []
    if (config.params) {
      for (let p in config.params) {
        let key = p
        if (Array.isArray(config.params[p])) {
          config.params[p].forEach((element: any) => {
            params.push(`${key}=${encodeURIComponent(element)}`)
          })
        } else {
          params.push(`${key}=${encodeURIComponent(config.params[p])}`)
        }
      }
    }
    if (config.params) {
      return Client.get(endpoint + '?' + params.join('&'), {
        ...config,
        method: 'GET',
      })
    }
    const Instance = getInstance({ headers: config.headers || {} })
    return Instance.post(endpoint, data, {
      params: config.params || {},
    })
  },
  delete: (endpoint: string, data: any, config: Config = {}) => {
    let params: any = []
    if (config.params) {
      for (let p in config.params) {
        let key = p
        if (Array.isArray(config.params[p])) {
          config.params[p].forEach((element: any) => {
            params.push(`${key}=${encodeURIComponent(element)}`)
          })
        } else {
          params.push(`${key}=${encodeURIComponent(config.params[p])}`)
        }
      }
    }
    if (config.params) {
      return Client.get(endpoint + '?' + params.join('&'), {
        ...config,
        method: 'DELETE',
      })
    } else {
    }
    const Instance = getInstance({ headers: config.headers || {} })
    return Instance.delete(endpoint, data)
  },

  put: (endpoint: string, data: any, config: Config = {}) => {
    let params: any = []
    if (config.params) {
      for (let p in config.params) {
        let key = p
        if (Array.isArray(config.params[p])) {
          config.params[p].forEach((element: any) => {
            params.push(`${key}=${encodeURIComponent(element)}`)
          })
        } else {
          params.push(`${key}=${encodeURIComponent(config.params[p])}`)
        }
      }
    }
    if (config.params) {
      return Client.get(endpoint + '?' + params.join('&'), {
        ...config,
        method: 'PUT',
      })
    } else {
    }
    const Instance = getInstance({ headers: config.headers || {} })
    return Instance.put(endpoint, data)
  },
}
